import { render, staticRenderFns } from "./DialogContentShareQuotes.vue?vue&type=template&id=f2ac11ec&scoped=true&"
import script from "./DialogContentShareQuotes.vue?vue&type=script&lang=js&"
export * from "./DialogContentShareQuotes.vue?vue&type=script&lang=js&"
import style0 from "./DialogContentShareQuotes.vue?vue&type=style&index=0&id=f2ac11ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ac11ec",
  null
  
)

export default component.exports